module.exports = __webpack_public_path__ + "static/media/PDF_86.bd3cf2d0.pdf";